import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule} from '@angular/common/http';
import { SlideshowModule } from 'ng-simple-slideshow';
import { CookieService } from 'ngx-cookie-service';

import { AppComponent } from './app.component';

import { LimitToPipe } from './pipes/limitto.pipe';
import { SanitizeHtmlPipe } from './pipes/sanitize.pipe';

import { FormsModule } from '@angular/forms';
import { DataProvider } from './providers/data.provider';
import { Settings } from './app.settings';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { ContactComponent } from './components/contact/contact.component';

import { HomePage } from './pages/home/home.page';
import { ContactPage } from './pages/contact/contact.page';

import { SpinnerComponent } from './components/spinner/spinner.component';
import { SpinnerProvider } from './components/spinner/spinner.provider';
import { SeoProvider } from './providers/seo.provider';
import { NavigationComponent } from './components/navigation/navigation.component';
import { CaptchaComponent } from './components/captcha/captcha.component';
import { ThankYouPage } from './pages/thankyou/thankyou.page';
import { EPKPage } from './pages/epk/epk.page';

import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PressKitPage } from './pages/presskit/presskit';
import { AppRoutingModule } from './app-routing.module';

@NgModule({
  declarations: [
    AppComponent,
    CaptchaComponent,
    ContactComponent,
    ContactPage,
    FooterComponent,
    HeaderComponent,
    HomePage,
    ThankYouPage,
    EPKPage,
    PressKitPage,
    LimitToPipe,
    NavigationComponent,
    SanitizeHtmlPipe,
    SpinnerComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    //RecaptchaModule.forRoot(),
    //RecaptchaFormsModule,
    SlideshowModule,
    PdfViewerModule
  ],
  providers: [
    CookieService,
    DataProvider,
    SeoProvider,
    Settings,
    SpinnerProvider
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
